import { IJob } from 'wisestep-api';
import create from 'zustand';

interface IBulkSelectedJobsStore {
  job: IJob;
  jobs: IJob[];
  updateSelectedJobs(args: IJob | null): void;
  removeSelectedJob(args: IJob): void;
  setSelectedJob(args: IJob): void;
}

const useJobsStore = create<IBulkSelectedJobsStore>((set) => ({
  jobs: [],
  job: {},
  updateSelectedJobs: (job: IJob | null) => {
    set((state) => ({
      jobs: job ? [...state.jobs, job] : [],
    }));
  },
  removeSelectedJob: (job: IJob) => {
    set((state) => ({
      jobs: state.jobs.filter((jobs) => `${jobs.id}` !== `${job.id}`),
    }));
  },
  setSelectedJob: (job: IJob) => set({ job }),
}));

export default useJobsStore;
